import axios from "axios";
import { PROCESS_AUTOMATION_SERVICE_URL } from "../Common/Constant/API";
import { commonRequestHeaders } from "../Common/request/headers";

const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    ...commonRequestHeaders(),
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

export const fetchPrManagedRepositories = async () => {
  const response = await axios.get(
    `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/git/repositories`,
    { headers: getHeaders() }
  );
  return response.data;
};

export const fetchCurrentTenantGitProvider = async () => {
  const response = await axios.get(
    `${PROCESS_AUTOMATION_SERVICE_URL}/utils/current-tenant/git-provider`,
    { headers: getHeaders() }
  );
  const provider = typeof response.data === "string"
    ? response.data
    : response.data?.message;
  const normalizedProvider = typeof provider === "string" ? provider.toUpperCase() : "";

  if (!["AZURE", "GITHUB"].includes(normalizedProvider)) {
    throw new Error("The server returned an invalid Git provider.");
  }

  return normalizedProvider;
};

export const fetchRepositoryBranches = async (repositoryId) => {
  const response = await axios.get(
    `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/pr-management/repositories/${repositoryId}/branches`,
    { headers: getHeaders() }
  );
  return response.data;
};

export const previewSourcePullRequest = async (sourcePullRequestUrl) => {
  const response = await axios.post(
    `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/pr-management/source-pr/preview`,
    { sourcePullRequestUrl },
    { headers: getHeaders() }
  );
  return response.data;
};

export const managePrFiles = async (payload) => {
  const response = await axios.post(
    `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/pr-management/files`,
    payload,
    { headers: getHeaders() }
  );
  return response.data;
};
